import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-confirm-docusign-dialog',
	templateUrl: './confirm-docusign-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./confirm-docusign-dialog.component.scss'],
	imports: [
		MatDialogTitle,
		CdkScrollable,
		MatDialogContent,
		NgIf,
		MatDialogActions,
		MatButton,
	],
})
export class ConfirmDocusignDialogComponent {
	readonly dialogRef = inject(MatDialogRef<ConfirmDocusignDialogComponent>);
	readonly data = inject<DialogData>(MAT_DIALOG_DATA);

	confirmDialog(confirmDialog: boolean): void {
		this.dialogRef.close(confirmDialog);
	}
}

export interface DialogData {
	title: string;
	type: string;
	fileName: string;
}
